export default __webpack_public_path__ + "static/media/E.8eb09edb.svg";